module.exports = __webpack_public_path__ + "img/faberlic.0ff66b3.jpg";